module.exports = __webpack_public_path__ + "img/thumbnail-header-1.a5e76f6.jpeg";